import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { Event } from '@app/client-socket-enum';
import { WindowRef } from './shared.service';

const SERVER_URL = environment.SocketUrl;

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  public webSocket: Socket;
  private currentlyListening: Event[] = []
  private subscribedCallsData: any[] = []
  public feedSocket: Socket;
  user: any;

  constructor(
    private windowRef: WindowRef
  ) { }

  initSocket(): void {
    this.user = JSON.parse(this.windowRef.nativeWindow?.localStorage.getItem(environment.tokenKey) || '{}');
    if (this.user && this.user.socketSession) {
      this.webSocket = io(SERVER_URL, {
        reconnection: true,
        forceNew:  true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 3,
        transports: ['websocket'],
        query: {
          socketSession: this.user.socketSession,
          EIO: 3
        }
      });
    }
  }

  closeSocket() {
    if (this.webSocket && this.webSocket.connected) {
      this.webSocket.close();
    }

    if (this.feedSocket && this.feedSocket.connected) {
      this.feedSocket.close();
    }
  }

  onEvent(event: Event): Observable<any> {
    return new Observable<any>((observer) => {
      if (this.webSocket) {
        this.currentlyListening.push(event)
        this.webSocket.on(event, (data) => {
          observer.next(data);
        });
      } else {
        observer.next(null);
      }
    });
  }

  checkIfAlredyConnected(event: Event) {
    return this.currentlyListening.indexOf(event) > -1
  }

  removeSocket(event: Event) {
    let idx = this.currentlyListening.indexOf(event)
    if (idx > -1) {
      this.currentlyListening.splice(idx, 1)
    }
  }

  connectFeedSocket() {
    const token = JSON.parse(this.windowRef.nativeWindow?.localStorage.getItem('pt') || '{}')?.access_token
    this.feedSocket = io(SERVER_URL, {
      path: "/streaming_feed/ltp",
      forceNew: true,
      reconnectionAttempts: 3,
      timeout: 2000,
      auth: { token },
      transports: ['websocket'],
    });
    this.feedSocket.on('connect', () => {
      if(this.subscribedCallsData.length){
        this.listenToAddStocks(this.subscribedCallsData)
      }
    })
  }

  listenToAddStocks(stockData: StockFeedData[]): Observable<any> {
    stockData.forEach((x) => {
      const existing = this.subscribedCallsData.find((y) => y.tradingSymbol===x.tradingSymbol && y.exchange===x.exchange)
      if(!existing){
        this.subscribedCallsData.push(x)
      }
    })
    this.feedSocket?.emit(Event.FEED_SUBSCRIBE, this.subscribedCallsData)
    return new Observable<any>((observer) => {
      this.feedSocket?.on(Event.TRADE_FEED, (data) => {
        observer.next(data)
      })
    })
  }

  unSubscribeToStockFeed(stockData: StockFeedData[]) {
    stockData.forEach((x) => {
      const existing = this.subscribedCallsData.findIndex((y) => y.tradingSymbol===x.tradingSymbol && y.exchange===x.exchange)
      if(existing > -1){
        this.subscribedCallsData.splice(existing, 1)
      }
    })
    this.feedSocket?.emit(Event.FEED_UNSUBSCRIBE, stockData)
  }
}


export interface StockFeedData {
  tradingSymbol: string,
  exchange: "NSE" | "BSE"
}